module.exports = __webpack_public_path__ + "static/media/modao.b3317d93.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/modao.ico
// module id = 148
// module chunks = 0